export default __webpack_public_path__ + "static/media/Website-Banner.a4d5219a.png";